import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import SpatialDistribution from './overview/SpatialDistribution';
import TimeDistribution from './overview/TimeDistribution';
import DataSummary from './overview/DataSummary';
import HoltWintersForecast from './time_series/HoltWintersForecast';
import DecompositionComponent from './time_series/DecompositionComponent';
import GrangerTestComponent from './time_series/GrangerTestComponent';
import HeatIndexCalculator from './regression/HeatIndexCalculator';
import RegressionModels from './regression/RegressionModels';
import Footer from './Footer';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <div className="App" class="d-flex flex-column min-vh-100">
      <Router hashType="noslash">
        <Header />
        <Route exact path="/" component={Home} />
        <Route path="/overview/SpatialDistribution" component={SpatialDistribution} />
        <Route path="/overview/TimeDistribution" component={TimeDistribution} />
        <Route path="/overview/summary" component={DataSummary} />
        <Route path="/ts/forecast" component={HoltWintersForecast} />
        <Route path="/ts/decomposition" component={DecompositionComponent} />
        <Route path="/ts/granger" component={GrangerTestComponent} />
        <Route path="/regression/HI-calculator" component={HeatIndexCalculator} />
        <Route path="/regression/models" component={RegressionModels} />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
